import { render, staticRenderFns } from "./NewDestete.vue?vue&type=template&id=58a7a375"
import script from "./NewDestete.vue?vue&type=script&lang=js"
export * from "./NewDestete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports